<script lang="ts" setup>
import { MainMenu } from './useMainMenu'
withDefaults(
  defineProps<{
    menu: MainMenu
    activeId?: string | null
  }>(),
  {
    activeId: null,
  },
)
</script>
<template>
  <ul class="sub-menus cul" role="menu" :aria-hidden="!activeId">
    <li v-for="item in menu" v-show="item.id === activeId" :key="item.id" role="none">
      <SubMenu v-if="item.items?.length" :item="item" :aria-labelledby="`menu-${item.id}`" />
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.sub-menus {
  position: absolute;
  top: 100%;
  left: calc(50% - 50vw);
  width: 100vw;

  background-color: var(--c-white);
  border-top: 1px solid var(--c-line-light);
  box-shadow: var(--shadow-light-lateral);
}
</style>
